<template>
  <b-form-group
    :label="$t('users.form.email')"
    label-for="email"
  >
    <validation-provider
      #default="{ errors }"
      :name="$t('users.form.email')"
      rules="required"
    >
      <b-form-input
        id="email"
        v-model="dataItem.email"
        :placeholder="$t('users.form.email')"
      />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { ValidationProvider } from 'vee-validate'
import {
  BFormGroup, BFormInput,
} from 'bootstrap-vue'
// eslint-disable-next-line no-unused-vars
import { required } from '@validations'

export default {
  name: 'UserName',
  components: {
    BFormGroup,
    BFormInput,
    ValidationProvider,
  },
  data() {
    return {
      required,
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['users/dataItem']
    },
  },
}
</script>

<style scoped>

</style>
